import { UserRankingDto, UserUtilizationDto } from '@repo/shared/dtos/analytics/UtilizationDto';
import { Activity, Clock, Calendar, Zap } from 'lucide-react';
import { formatNumber } from '../../utils/dataUtils';
import { dateUtils } from '../../utils/dateUtils';
import { useIsMobile } from '../../../../hooks/useIsMobile';

interface UserStatsProps {
  user: UserRankingDto | UserUtilizationDto;
}

export function UserStats({ user }: UserStatsProps) {
  const isMobile = useIsMobile();
  const stats = [
    {
      label: 'Total Sessions',
      value: formatNumber(user.total_sessions),
      icon: <Activity className="h-5 w-5 text-[var(--anl-text-muted)]" />,
    },
    {
      label: 'Total Minutes',
      value: formatNumber(Math.round(user.total_minutes)),
      icon: <Clock className="h-5 w-5 text-[var(--anl-text-muted)]" />,
    },
    {
      label: `${dateUtils.currentMonthLabel()} Sessions`,
      value: formatNumber(user.sessions_this_month),
      icon: <Calendar className="h-5 w-5 text-[var(--anl-text-muted)]" />,
    },
    {
      label: `${dateUtils.currentMonthLabel()} Minutes`,
      value: formatNumber(Math.round(user.minutes_this_month)),
      icon: <Zap className="h-5 w-5 text-[var(--anl-text-muted)]" />,
    },
  ];

  return (
    <div className={`grid grid-cols-2 ${isMobile ? 'mb-4 gap-3' : 'mb-6 grid-cols-4 gap-4'}`}>
      {stats.map((stat, index) => (
        <div
          key={index}
          className="rounded-lg border border-[var(--anl-border)] bg-[var(--anl-surface-elev)] p-4"
        >
          <div className="mb-2 flex items-center space-x-2">
            {stat.icon}
            <span className="text-sm font-medium text-[var(--anl-text-muted)]">{stat.label}</span>
          </div>
          <div className={`font-bold text-[var(--anl-text)] ${isMobile ? 'text-base' : 'text-xl'}`}>{stat.value}</div>
        </div>
      ))}
    </div>
  );
}
